import { render, staticRenderFns } from "./champ-specialite.html?vue&type=template&id=e895926a&scoped=true&external"
import script from "./champ-specialite.js?vue&type=script&lang=js&external"
export * from "./champ-specialite.js?vue&type=script&lang=js&external"
import style0 from "./champ-specialite.scss?vue&type=style&index=0&id=e895926a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e895926a",
  null
  
)

export default component.exports